import { type Meta } from '../types/docs';

export const TEAM_INVITE_CTA_CLICKED_LOCATIONS = [
  'workspace_settings_dropdown',
  'asset_share_link',
  'board_share_link',
  'collection_share_link',
  'canvas_share_link',
  'side_nav',
] as const;

export type TeamInviteCtaClickedLocation = (typeof TEAM_INVITE_CTA_CLICKED_LOCATIONS)[number];

const META: Meta = {
  description: 'Called when a user clicks on the team invite nudge or CTA',
  name: 'team_invite_cta_clicked',
  params: [
    {
      description: 'The location where the team invite CTA was clicked',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...TEAM_INVITE_CTA_CLICKED_LOCATIONS],
    },
  ],
};

export default META;
